// extracted by mini-css-extract-plugin
export default {"icon":"imagecard_icon__Y1IPF"};